export default "__VITE_ASSET__CTdsOAhI__"